import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {AgentGuidance} from '../agent-guidance/AgentGuidance';
import {ProgressList} from '../progress-list/ProgressList';

import './styles.scss';
import {IconSizes} from '@techsee/techsee-ui-common/lib/icons/large-rounded-icon';
import {InviteDeviceType} from '../../../_contracts/InviteContracts';

export interface GuidenceProgressItem {
    icon: string;
    iconColor: string;
    iconSize?: IconSizes;
    iconNoBorder?: boolean;
    isActive: boolean;
    isIconAnimated: boolean;
    label: string;
    subLabel?: string;
    classNameLabel?: string;
    classNameItem?: string;
}

export interface AgentGuidanceItem {
    stepType: string;
    stepNum: number;
    displayStepNum?: number;
    stepText: string;
    deviceType: InviteDeviceType;
    tooltipPosition?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
    };
    maxHeight?: string;
}

export interface GuidanceProgressProps {
    progressList: GuidenceProgressItem[];
    guidanceItems: AgentGuidanceItem[];
    renderActions?: (label: string) => React.ReactNode;
    messageIndication?: string;
    customClassName?: string;
}

export class GuidanceProgress extends TechseeBaseComponent<GuidanceProgressProps> {
    renderInternal() {
        const {progressList, guidanceItems, renderActions, messageIndication, customClassName} = this.props;
        const hasMultipleItems = guidanceItems.length > 1;
        const hasTwoItems = guidanceItems.length === 2;
        const hasFiveItems = guidanceItems.length === 5;
        const hasMany = guidanceItems.length > 3;
        const hasProgressList = progressList && progressList.length > 0;

        let className = 'guidance-progress row';

        customClassName && (className += ` ${customClassName}`);

        if (!hasProgressList) {
            // When no progress list, render guidance items in full width
            return (
                <div className={className}>
                    <div className={'col-sm-12 guidance-items-centered'}>
                        {guidanceItems.map((item, index) => (
                            <AgentGuidance
                                key={index}
                                stepType={item.stepType}
                                stepNum={item.stepNum}
                                displayStepNum={item.displayStepNum}
                                deviceType={item.deviceType}
                                stepText={item.stepText}
                                tooltipPosition={item.tooltipPosition}
                                maxHeight={item.maxHeight}
                            />
                        ))}
                    </div>
                </div>
            );
        }

        if (!customClassName && hasMultipleItems && !hasTwoItems) {
            className += ' guidance-multiple-items';
        }
        if (!customClassName && hasFiveItems) {
            className += ' guidance-five-items';
        }
        if (!customClassName && hasMany && !hasTwoItems) {
            className += ' guidance-many-items';
        }

        if (!customClassName && hasTwoItems) {
            className += ' guidance-two-items';
        }

        return (
            <div className={className}>
                <div className={'col-left col-sm-4'}>
                    <ProgressList progressList={progressList} renderActions={renderActions} />
                    {messageIndication && (
                        <div
                            className={'guidance-progress-message-indication'}
                            dangerouslySetInnerHTML={{__html: messageIndication}}
                        />
                    )}
                </div>
                <div className={'col-left col-sm-4 mid-col'}>
                    {guidanceItems.map((item, index) => (
                        <AgentGuidance
                            key={index}
                            stepType={item.stepType}
                            stepNum={item.stepNum}
                            displayStepNum={item.displayStepNum}
                            deviceType={item.deviceType}
                            stepText={item.stepText}
                            tooltipPosition={item.tooltipPosition}
                            maxHeight={item.maxHeight}
                        />
                    ))}
                </div>
                <div className={'col-left col-sm-4'}>&nbsp;</div>
            </div>
        );
    }
}
